// function adjustFullHeight() {
//     const mainVisual = document.querySelector('.main-first-visual');
//     if (mainVisual) {
//       mainVisual.style.height = `${window.innerHeight}px`;
//     }
//   }

//   // 初期設定
//   adjustFullHeight();

//   // ウィンドウサイズ変更時に再調整
//   window.addEventListener('resize', adjustFullHeight);

// function adjustFullHeight() {
//     const mainVisual = document.querySelector('.main-first-visual');
//     if (mainVisual) {
//       // ヘッダーの高さを設定（画面幅に応じて変化）
//       const headerHeight = window.innerWidth < 990 ? 64 : 82.19;
      
//       // 表示可能な高さを計算
//       const viewHeight = window.innerHeight - headerHeight;

//       // 高さを適用
//       mainVisual.style.height = `${viewHeight}px`;
//     }
//   }

//   // 初期設定
//   adjustFullHeight();

//   // ウィンドウサイズ変更時に再調整
//   window.addEventListener('resize', adjustFullHeight);

document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.preload');
    const mainVisual = document.querySelector('.main-first-visual');

    let imagesLoaded = 0;

    // 画像がロードされるまで待機
    images.forEach((img) => {
      img.onload = () => {
        imagesLoaded++;
        if (imagesLoaded === images.length) {
          mainVisual.classList.add('loaded'); // アニメーション開始クラスを追加
        }
      };

      // 画像がキャッシュ済みの場合にもイベントを強制発火
      if (img.complete) {
        img.onload();
      }
    });
  });